/**
 * @file cover-layout.ts
 * @description Общее для «как показать картинку шапки» (phase19.16; решения
 * пользователя 2026-10-12): обложка встроенной шапки ленты блога
 * (`SiteBlogOptions.coverLayout/coverDim/coverTextTone`) и баннер шапки
 * категории (`SiteCatalogOptions.categoryBanner`). Один набор раскладок,
 * одни тона текста и одно правило контраста — чтобы блог, каталог и фото-фон
 * секции не разошлись. Затемнение — числом 0–60 % с одними пределами
 * (`DIM_FIELD` в page-bg, SB120; прежние ступени — подсказки поля).
 * Подписи раскладок у каждого раздела свои (обложка / фото).
 */

/**
 * Раскладка картинки шапки: фоном во всю ширину или сбоку от текста.
 * Если shared добавит вариант, вызовы схемы с типом из shared перестанут
 * сходиться с этим типом — компилятор подскажет, где дорисовать.
 */
export type CoverLayout = "background" | "side-right" | "side-left";

/** Тон текста поверх картинки. */
export type CoverTextTone = "light" | "dark";

/** Варианты тона текста для `Segmented`. */
export const COVER_TEXT_TONES: ReadonlyArray<{ value: CoverTextTone; label: string }> = [
  { value: "light", label: "Светлый" },
  { value: "dark", label: "Тёмный" },
];

/**
 * Риск нечитаемого текста: светлый текст поверх фото почти без затемнения
 * (меньше 20 %). Только для раскладки «фоном» — сбоку текст не на фото.
 * Фото-фон секции всегда «фоном».
 */
export function coverLowContrast(layout: CoverLayout, tone: CoverTextTone, dim: number): boolean {
  return layout === "background" && tone === "light" && dim < 0.2;
}

/** Предупреждение при `coverLowContrast` — обложка блога и фото-фон секции. */
export const LOW_CONTRAST_TEXT = "Текст может потеряться на фото — добавьте затемнение 40 % или выберите тёмный текст.";
